import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { SaveCancel, Label } from 'fw/components';
import { Form, PasswordBox, TextBox } from 'fw/forms';
import { PasswordInstructions } from 'areas/shared/components';
import * as FormManager from 'fw/forms/form/FormManager'
import * as API from 'modules/app/API'
import * as Notifications from 'fw/globals/Notifications'
import * as Help from 'modules/app/Help'
import * as App from 'modules/app/App';

class ExpiredPassword extends React.Component {
	constructor(props) {
		super(props);
		this.state = this.initialState();
	}

	initialState = () => {
		return {
			form: {},
			userId: ""
		};
	}

	save = () => {
		if (!this.validate())
			return;

		const form = this.state.form;

		let rq = {
			userId: this.state.userId,
			newPassword: form.newPassword,
			oldPassword: form.oldPassword
		};

		API.Security.post('/recovery/renewPassword', rq,
			{
				success: (r) => {
					Notifications.success(r.message);

					// Logout
					App.logout();

					// Redirect
					window.location.href = "/";
				},
				error: (r) => {
					Notifications.error(r.error.errorMessage);
				}
			});
	}

	validate = () => {
		const form = this.state.form;

		if (form.newPassword !== form.confirmPassword) {
			Notifications.error("The password and confirmation password do not match");
			return false;
		}

		return true;
	}

	cancel = () => {
		this.props.history.push('/');
	}

	onSubmit = () => {
		this.save();
	}

	onCancel = () => {
		const me = this;
		FormManager.checkUnsavedChanges(function () {
			me.cancel();
		})
	}

	onChange = (form) => {
		this.setState({ form });
	}

	setHelp = () => {
		if (this.props.helpKey)
			Help.setHelp(this.props.helpKey)
		else
			Help.clearHelp();
	}

	componentDidMount() {
		this.setState({ userId: App.context().userId })
		this.setHelp();
	}

	render() {
		return (
			<React.Fragment>
				<h2>Expired Password</h2>
				<hr />
				<Form
					onChange={this.onChange}
					onSubmit={this.onSubmit}
					values={this.state.form}
					unsavedChangesWarning={false}
					ref={(form) => this._form = form}>
					<Row>
						<Col md={7}>
							<p>Your password has expired and must be changed. Please enter a new Password.</p>
							<FormGroup>
								<Label htmlFor="oldPassword" required>Current password</Label>
								<TextBox name="oldPassword" type="password" required />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="newPassword" required>New password</Label>
								<PasswordBox name="newPassword" required />
							</FormGroup>
							<FormGroup>
								<Label htmlFor="confirmPassword" required>Confirm new password</Label>
								<PasswordBox name="confirmPassword" required />
							</FormGroup>
						</Col>
						<Col md={5}>
							<PasswordInstructions />
						</Col>
					</Row>
					<div className="text-center">
						<hr />
						<SaveCancel onCancel={this.onCancel} />
					</div>
				</Form>
			</React.Fragment>)
	}
}


export default ExpiredPassword;



// WEBPACK FOOTER //
// ./src/areas/public/expiredPassword/ExpiredPassword.js